import api from "./api";

const qs = (p) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
);

const cotacaoService = {
  meta: () => api("GET", "/cotacao/meta"),
  listar: (p = {}) => api("GET", `/cotacao?${qs(p)}`),
  buscarPorId: (id) => api("GET", `/cotacao/${id}`),
  mapa: (id) => api("GET", `/cotacao/${id}/mapa`),
  criar: (data) => api("POST", "/cotacao", data),
  atualizar: (id, data) => api("PUT", `/cotacao/${id}`, data),
  salvarResposta: (id, idCotFornecedor, data) =>
    api("PUT", `/cotacao/${id}/respostas/${idCotFornecedor}`, data),
  alterarStatus: (id, status) => api("PATCH", `/cotacao/${id}/status`, { status }),
  enviarConvites: (id, body = {}) => api("POST", `/cotacao/${id}/enviar-convites`, body),
  listarEscolhas: (id) => api("GET", `/cotacao/${id}/escolhas`),
  salvarEscolhas: (id, escolhas) => api("PUT", `/cotacao/${id}/escolhas`, { escolhas }),
  autoMenorPreco: (id) => api("POST", `/cotacao/${id}/escolhas/auto-menor-preco`),
  gerarPedidos: (id, body = {}) => api("POST", `/cotacao/${id}/gerar-pedidos`, body),
  listarPedidos: (id) => api("GET", `/cotacao/${id}/pedidos`),
  imprimirMapa: (id) => api("GET", `/cotacao/${id}/mapa/imprimir`),
  enviarLembretes: (id, body = {}) => api("POST", `/cotacao/${id}/lembretes`, body),
  sugestaoItens: (p = {}) => api("GET", `/cotacao/sugestao-itens?${qs(p)}`),
};

export default cotacaoService;
